import { Component, OnChanges, OnInit, SimpleChanges, inject, input } from '@angular/core';
import { ZiroFormAbstractDirective } from '../../../../forms/ziro-form-abstract.directive';
import { ZiroSelectConfig, ZiroSelectOption } from '../../../../forms/fields/select/ziro-select.component';
import { PhoneButtonTemplateRef } from '../../../../shared/models/generated/ziroModels';
import { ZiroFormStateService } from '../../../../forms/ziro-form-state.service';
import { ZiroFormConfig } from '../../../../forms/ziro-forms-models';
import { filter, first } from 'rxjs/operators';
import { PhoneUiContext } from '../../../../shared/phone-buttons/contexts/phone-ui.context';
import { ExtMobilityUiContext } from '../../../../shared/phone-buttons/contexts/ext-mobility-ui.context';
import { Observable } from 'rxjs';

interface PhoneButtonTemplateFormData {
  template: ZiroSelectOption;
}

@Component({
  selector: 'ziro-phone-button-template-form',
  templateUrl: './phone-button-template-form.component.html',
  standalone: false,
})
export class PhoneButtonTemplateFormComponent
  extends ZiroFormAbstractDirective<PhoneButtonTemplateRef, PhoneButtonTemplateFormData>
  implements OnInit, OnChanges
{
  protected _ziroFormStateService: ZiroFormStateService;
  private phoneUiContext = inject(PhoneUiContext, { optional: true });
  private extensionMobilityUiContext = inject(ExtMobilityUiContext, { optional: true });

  readonly possibleOptions = input<PhoneButtonTemplateRef[]>();

  formConfig: ZiroFormConfig;

  private static _mapPossibleOptions(options: PhoneButtonTemplateRef[]): ZiroSelectOption[] {
    return options.map((opt) => ({ label: opt.name, value: opt }));
  }

  protected submit(): Observable<boolean> {
    return (this.phoneUiContext || this.extensionMobilityUiContext).isSaving$.pipe(
      filter((isSaving) => !isSaving),
      first(),
    );
  }

  ngOnInit(): void {
    const options = PhoneButtonTemplateFormComponent._mapPossibleOptions(this.possibleOptions());
    this.formConfig = {
      fields: {
        template: {
          label: 'tkey;pages.details.phoneSettings.phone_button_template.label',
          dataAutomation: 'phone-button-template-select',
          componentConfig: new ZiroSelectConfig({ options }),
          required: true,
        },
      },
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (changes.possibleOptions && !changes.possibleOptions.firstChange) {
      const templateConfig = new ZiroSelectConfig({
        options: PhoneButtonTemplateFormComponent._mapPossibleOptions(changes.possibleOptions.currentValue),
      });
      const templateComponent = this.fieldComponents.find((field) => field.fieldId() === 'template');
      templateComponent.fieldData = this.toFormData(this.entity).template;
      templateComponent.applyComponentConfig(templateConfig);
    }
  }

  toEntity = (formData: PhoneButtonTemplateFormData): PhoneButtonTemplateRef => {
    return formData?.template?.value;
  };

  toFormData = (entity: PhoneButtonTemplateRef): PhoneButtonTemplateFormData => {
    return {
      template: {
        label: entity?.name,
        value: entity,
      },
    };
  };
}
